import type { CartItem } from "../types/cart.types";
import {
    productQuantity,
    UNIT_MEASURE_CODE,
} from "@ecommerce/shared-utils/src/quantity/productQuantity";

export const getCartCount = (items: CartItem[]): number =>
    productQuantity.normalize(
        items.reduce((total, item) => total + item.quantity, 0),
        2,
    );

export const getCartBadgeCount = (items: CartItem[]): number => {
    const onlyUnitProducts = items.every(
        (item) => (item.unitMeasureCode ?? UNIT_MEASURE_CODE) === UNIT_MEASURE_CODE,
    );
    if (onlyUnitProducts) return getCartCount(items);

    return new Set(items.map((item) => `${item.idProduct}\u0000${item.idProductVariant}`)).size;
};

export const getCartTotal = (items: CartItem[]): number =>
    productQuantity.normalize(
        items.reduce((total, item) => total + item.price * item.quantity, 0),
        2,
    );
